import { NgModule } from '@angular/core';
import { AboutDialogModule } from './components/about-dialog/about-dialog.module';
import { AccessDialogModule } from './components/access-dialog/access-dialog.module';
import { AddTeamModelDialogModule } from './components/add-team-model-dialog/add-team-model-dialog.module';
import { ClipboardDialogModule } from './components/clipboard-dialog/clipboard-dialog.module';
import { ConfirmDialogModule } from './components/confirm-dialog/confirm-dialog.module';
import { DomainJoinDialogModule } from './components/domain-join-dialog/domain-join-dialog.module';
import { GroupRestrictionDialogModule } from './components/group-restriction-dialog/group-restriction-dialog.module';
import { LegacyDialogModule } from './components/legacy-dialog/legacy-dialog.module';
import { LimitDialogModule } from './components/limit-dialog/limit-dialog.module';
import { NpsDialogModule } from './components/nps-dialog/nps-dialog.module';
import { SaveBookmarkDialogModule } from './components/save-bookmark-dialog/save-bookmark-dialog.module';
import { SaveModuleDialogModule } from './components/save-module-dialog/save-module-dialog.module';
import { WelcomeTourDialogModule } from './components/welcome-tour-dialog/welcome-tour-dialog.module';
import { DialogState } from './state/dialog.state';
import { NgxsModule } from '@ngxs/store';
import { TeamInviteDialogModule } from './components/team-invite-dialog/team-invite-dialog.module';
import { DeleteAccountDialogModule } from './components/delete-account-dialog/delete-account-dialog.module';
import { CancelSubscriptionDialogModule } from './components/cancel-subscription-dialog/cancel-subscription-dialog.module';
import { ImageDialogModule } from './components/image-dialog/image-dialog.module';
import { QuizSettingsModule } from './components/quiz-settings-dialog/quiz-settings-dialog.module';
import { TabsModule } from '../shared/components/tabs/tabs.module';
import { LocalFormsModule } from '../shared/components/local-forms/forms.module';
import { SharedModule } from '../shared/shared.module';
import { TeamTransferDialogModule } from './components/team-transfer-dialog/team-transfer-dialog.module';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      DialogState
    ]),

    AboutDialogModule,
    AccessDialogModule,
    AddTeamModelDialogModule,
    ClipboardDialogModule,
    ConfirmDialogModule,
    DomainJoinDialogModule,
    GroupRestrictionDialogModule,
    LegacyDialogModule,
    LimitDialogModule,
    NpsDialogModule,
    SaveBookmarkDialogModule,
    SaveModuleDialogModule,
    WelcomeTourDialogModule,
    TeamInviteDialogModule,
    DeleteAccountDialogModule,
    CancelSubscriptionDialogModule,
    ImageDialogModule,
    QuizSettingsModule,
    TeamTransferDialogModule,
    
    TabsModule,
    LocalFormsModule,
    SharedModule
  ],
  exports: [
    AboutDialogModule,
    AccessDialogModule,
    AddTeamModelDialogModule,
    ClipboardDialogModule,
    ConfirmDialogModule,
    DomainJoinDialogModule,
    GroupRestrictionDialogModule,
    LegacyDialogModule,
    LimitDialogModule,
    NpsDialogModule,
    SaveBookmarkDialogModule,
    SaveModuleDialogModule,
    WelcomeTourDialogModule,
    TeamInviteDialogModule,
    DeleteAccountDialogModule,
    CancelSubscriptionDialogModule,
    ImageDialogModule,
    QuizSettingsModule,
    TeamTransferDialogModule
  ],
  declarations: []
})
export class DialogModule { }
